<template>
  <BittsLoading :is-loading="!isReady">
    <div class="api-integrations-tab">
      <ApiTabEmptyState
        v-if="!oAuthApplications.length"
        title="No integrations yet"
        description="Create an integration to get a client ID and secret, then exchange them for tokens using the OAuth 2.0 flow."
        create-cta-text="Create integration"
        :icon="['fak', 'integration']"
        @create="openCreate('integrations')"
      />
      <template v-else>
        <ApiIntegrationCard
          v-for="integration in oAuthApplications"
          :key="integration.id"
          :integration="integration"
          @settings="openDetail('integrations', integration.id)"
        />
      </template>
    </div>
  </BittsLoading>
</template>

<script setup lang="ts">
import { BittsLoading } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';
import { storeToRefs } from 'pinia';

import { useOauthApplicationStore } from '@/stores';

import ApiIntegrationCard from '../components/ApiIntegrationCard.vue';
import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';
import useApiRoutes from '../useApiRoutes';

useHead({ title: 'API Integrations - Crossbeam' });

const { openCreate, openDetail } = useApiRoutes();
const { oAuthApplications, ready: isReady } = storeToRefs(
  useOauthApplicationStore(),
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-integrations-tab {
  @apply flex flex-col gap-16;
}
</style>
